module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "gallery-container"
  }, _vm._l((_vm.gallery), function(image, imageIndex) {
    return _c('div', {
      staticClass: "gallery-thumbnail",
      style: ({
        'background-image': ("url(/static/images/agc/gallery/" + image + ")")
      }),
      on: {
        "click": function($event) {
          _vm.index = imageIndex
        }
      }
    })
  }), 0), _vm._v(" "), _c('gallery', {
    attrs: {
      "images": _vm.gallery.map(function (image) { return ("/static/images/agc/gallery/" + image); }),
      "index": _vm.index,
      "options": {
        displayClass: 'blueimp-gallery-display-fix'
      }
    },
    on: {
      "close": function($event) {
        _vm.index = null
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1733ec62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AgcGallery.vue
// module id = 937
// module chunks = 0